// Recovered compiled webpack factory 18326. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, { AttributionCapture: () => a });
  var r = n(12115),
    i = n(85396);
  function a() {
    return (
      (0, r.useEffect)(() => {
        (0, i.AT)();
      }, []),
      null
    );
  }
}
